<template>
  <van-dialog title="积分详情" @close="onClose">
    <div class="integral" slot="main">
      <div class="condition">
        <div class="time">
          <span>时间筛选：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-date-picker
            v-model="month"
            @change="selectData"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择月份">
          </el-date-picker>
        </div>
        <div class="time">
          <span>学科筛选：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <p>
            <span :class="{active: subjectCode === item.code}"
              @click="toggleSubject(item.code)"
              v-for="item in subjects" :key="item.code">
              {{item.name}}
            </span>
          </p>
        </div>
      </div>
      <div v-if="integralDetails.length" class="integral-list">
        <div class="integral-details" v-for="(item, index) in integralDetails" :key="index">
          <p class="book-name">{{item.detail}}<span>+{{item.score}}分</span></p>
          <p class="time">{{item.created_at}}</p>
        </div>
      </div>
      <div v-else class="no-data">
        暂无数据
      </div>
      <van-page :total="total" :page-size="pageSize" @changePage="changePage" />
    </div>
  </van-dialog>
</template>

<script>
/* eslint-disable */
import api from '@/api/user';
import server from '@/api/course';
import {
  DatePicker,
} from 'element-ui';
import VanDialog from './Dialog.vue';
import VanPage from './Page.vue';

export default {
  props: {
  },
  components: {
    VanPage,
    VanDialog,
    ElDatePicker: DatePicker,
  },
  data() {
    return {
      page: 1,
      pageSize: 5,
      subjectCode: '',
      month: '',
      total: 0,
      integralDetails: [],
      subjects: [{
        name: '全部',
        code: '',
      }],
    };
  },
  methods: {
    changePage(curPage) {
      this.page = curPage;
      this.getIntegralDetails();
    },
    selectData() {
      this.page = 1;
      this.getIntegralDetails();
    },
    toggleSubject(code) {
      this.subjectCode = code;
      this.page = 1;
      this.getIntegralDetails();
    },
    getIntegralDetails() {
      api.getIntegralDetails({
        now_page: this.page,
        per_page: this.pageSize,
        time: this.month,
        project_code: this.subjectCode,
      })
        .then((data) => {
          this.total = data.total;
          this.integralDetails = data.data;
        })
    },
    getCourseList() {
      server.getWrongBookCourses()
        .then((data) => {
          this.subjects.push(...data);
        })
    },
    onClose() {
      this.$emit('close');
    },
  },
  created() {
    this.getCourseList();
    this.getIntegralDetails();
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.integral {
  padding: 2%;
  width: 54vw;
  height: 74vh;
  color: #333;
  box-sizing: border-box;
  .condition {
    padding: 3%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 22%;
    border-radius: 24px;
    box-sizing: border-box;
    box-shadow: 1px 1px 5px #999;
    .time {
      display: flex;
      align-items: center;
      font-size: 2vh;
      font-weight: bold;
      p {
        flex: 1;
        display: flex;
        align-items: center;
        span {
          margin-right: 5%;
          font-weight: normal;
          font-size: 1.8vh;
          color: #666;
          cursor: pointer;
          &.active {
            font-size: 2vh;
            color: #5A5FEF;
          }
        }
      }
    }
  }
  &-list {
    height: 68%;
    overflow: hidden;
    .integral-details {
      margin-top: 2%;
      border-bottom: 1px solid #f1f1f1;
      p {
        margin: 0;
      }
      .book-name {
        font-size: 2vh;
        font-weight: bold;
        span {
          float: right;
          color: #5A5FEF;
        }
      }
      .time {
        padding: 1% 0 1.5%;
      }
    }
  }
  .no-data {
    margin-top: 20%;
    text-align: center;
    font-size: 4vh;
    font-weight: bold;
    color: #5A5FEF;
  }
}
</style>
